import {
  IRegion,
  IHeartBeat,
  ReportHearbeatResponse,
  Operation,
  IMetrics,
  WsError,
  WsErrorCodes,
  WsErrorTypes,
  ISessionManager,
  ILogger,
  IWSBrokerService,
  IpFallbackEndpoint,
  IHeartBeatCore,
} from '@amzn/work-spaces-web-client-core-lib';

export class HeartBeat implements IHeartBeat {
  private readonly wsBrokerClient: IWSBrokerService;
  private readonly sessionManager: ISessionManager;
  private readonly logger: ILogger;
  private readonly metrics: IMetrics;
  private readonly heartBeatCore: IHeartBeatCore;

  constructor(
    wsBrokerClient: IWSBrokerService,
    sessionManager: ISessionManager,
    logger: ILogger,
    metrics: IMetrics,
    heartBeatCore: IHeartBeatCore
  ) {
    this.sessionManager = sessionManager;
    this.wsBrokerClient = wsBrokerClient;
    this.logger = logger;
    this.metrics = metrics;
    this.heartBeatCore = heartBeatCore;
  }

  async getHeartBeatInfo(regCode?: string, region?: IRegion) {
    const heartbeatMetrics = this.metrics.embark(Operation.Heartbeat);
    if (!regCode || !region) {
      throw new WsError(
        WsErrorTypes.ERROR_TYPE_HEARTBEAT,
        WsErrorCodes.ERROR_INVALID_REG_CODE
      );
    }
    const sessionContext = this.sessionManager.get('sessionContext');
    const sessionId = sessionContext?.SessionId as string;
    const authToken = this.sessionManager.get('authToken')?.Value as string;
    try {
      const response = await this.wsBrokerClient.getHeartBeatInfo(
        authToken,
        sessionId,
        regCode,
        region
      );
      this.logger.info(`Retrieved heartbeat info for ${regCode}`);
      // Update sessionInfo before emitting metrics
      this.sessionManager.set({
        sessionContext: response.SessionContext,
        heartBeatEndpoint: new IpFallbackEndpoint(
          response.heartBeatEndpoint,
          response.heartbeatDualStackEndpoint
        ),
        heartBeatSessionId: response.heartBeatSessionId,
        HeartBeatContext: response.HeartBeatContext,
      });
      this.metrics.emitMetricOperation(heartbeatMetrics);
      return response;
    } catch (error) {
      this.logger.error(
        `Retrieved heart beat info for ${regCode} and the error is ${error}`
      );
      this.metrics.emitMetricOperation(heartbeatMetrics, error);
      if (error instanceof WsError) {
        throw error;
      } else {
        throw new WsError(
          WsErrorTypes.ERROR_TYPE_HEARTBEAT,
          WsErrorCodes.ERROR_CM_REQUEST_FAILED
        );
      }
    }
  }

  async reportHeartBeat(
    heartBeatEndpoint: IpFallbackEndpoint
  ): Promise<ReportHearbeatResponse> {
    const heartbeatSessionId = this.sessionManager.get(
      'heartBeatSessionId'
    ) as string;
    const heartbeatSessionToken = this.sessionManager.get('sessionContext')
      ?.AuthToken?.Value as string;
    const heartbeatMetrics = this.metrics.embark(Operation.Heartbeat);

    try {
      const response = await this.heartBeatCore.reportHeartBeatCore(
        heartbeatSessionToken,
        heartbeatSessionId,
        heartBeatEndpoint
      );
      this.metrics.emitMetricOperation(heartbeatMetrics);
      return response;
    } catch (error) {
      this.metrics.emitMetricOperation(heartbeatMetrics, error);
      throw error;
    }
  }
}
